import { Text } from '@backstage/ui';
import { Icon } from '@iconify/react';
import { Card } from '@ipen-portal/plugin-common-react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import classes from './SupportCenterHomeCard.module.css';

const TILES: {
  description: string;
  icon: string;
  iconColor?: 'error' | 'info' | 'valid' | 'warning';
  title: string;
  to: string;
}[] = [
  {
    description: 'Find support, view service status, or report an incident for any iPEN Product.',
    icon: 'ri:alert-line',
    title: 'Problem?',
    to: '/report-incident',
  },
  {
    description: 'Submit a demand or contact the iPEN Portal team.',
    icon: 'ri:lightbulb-line',
    title: 'Idea?',
    to: '/create/templates/default/ipen-demand-new',
  },
  {
    description: 'All iPEN Products are available.',
    icon: 'ri:checkbox-circle-fill',
    iconColor: 'valid',
    title: 'Platform Status',
    // TODO: Link to the platform status page once it exists.
    to: '/',
  },
];

export const SupportCenterHomeCard = () => (
  <Card title="Support Center">
    <div className={classes.root}>
      <div className={classes.tiles}>
        {TILES.map(({ description, icon, iconColor, title, to }) => (
          <div className={classes.tile} key={title}>
            <div className={classes.heading}>
              <Icon aria-hidden="true" className={clsx(iconColor && classes[iconColor])} icon={icon} />
              <Link className={classes.link} to={to}>{title}</Link>
            </div>
            <Text as="p" variant="body-small">{description}</Text>
          </div>
        ))}
      </div>
    </div>
  </Card>
);
